export const ALUMNI_NETWORK_SUCCESS = "ALUMNI_NETWORK_SUCCESS";
export const ALUMNI_NETWORK_SENDING = "ALUMNI_NETWORK_SENDING";
export const ALUMNI = "ALUMNI";
export const ALUMNI_LOADING = "ALUMNI_LOADING";
export const ALUMNI_NETWORK_EXIT_SENDING = "ALUMNI_NETWORK_EXIT_SENDING";
